import * as React from 'react';
import newLeftbanner from "../../assets/gif/banner-web.gif";
import newPremium from "../../assets/images/newPremium.webp";
import MKBox from '../../components/MKBox';
import "../../App.css";
import { Grid } from '@mui/material';
import { Ticker } from '../../components/Ticker/Ticker'; // adjust path to wherever you put it

export function Banner() {
    return (
        <MKBox className='banner'>
            <Grid container p={0} m={1}>
                <Grid item lg={12} md={12}>
                    <MKBox sx={{ position: "relative" }}>
                        <MKBox component="img"
                            sx={{
                                maxWidth: "100%",
                                height: "auto",
                                mt: "20px",
                                mb: "0px",
                                borderRadius: "24px"
                            }}
                            src={newLeftbanner}
                        />
                        <Ticker />
                    </MKBox>
                    <MKBox component="img"
                        sx={{
                            maxWidth: "100%",
                            height: "auto",
                            mt: "20px",
                            mb: "50px",
                        }}
                        src={newPremium}
                    />
                </Grid>
            </Grid>
        </MKBox>
    )
}